/**
 * Creates viewport-triggered fade-in effects.
 */
document.addEventListener('DOMContentLoaded', function() {
    const isMobile = window.innerWidth <= 1024;
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: isMobile ? 0.09 : 0.15
       
    };

    const fadeElements = document.querySelectorAll('.fade-in');
    const fadeElementsMobileOnly = document.querySelectorAll('.fade-in-mobile-only');
    //console.log(fadeElements);

    // Check if fadeElements is not empty
    if (fadeElements?.length > 0) {
        const fadeObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                //console.log(entry);
                // Add 'visible' class when entering viewport
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                } 
                // else {
                //     // Remove 'visible' class when leaving viewport
                //     entry.target.classList.remove('visible');
                // }
            });
        }, observerOptions);

        fadeElements.forEach(element => fadeObserver.observe(element));
    }

    if (fadeElementsMobileOnly?.length > 0) {
        const fadeObserverMobile = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, observerOptions);

        fadeElementsMobileOnly.forEach(element => fadeObserverMobile.observe(element));
    }

});